module.exports = {
  "version": "0.26.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 73
// module chunks = 1